// Source-line candidates for the invoice workflow editor, built from an
// already-loaded supplier order (existing supplierOrdersApi query owner).
// Options carry business labels (order number + product); IDs travel as
// values only. WP11: with the ZD's `invoiceCoverage` loaded, each candidate
// also carries its uninvoiced remainder (label + prefill of a linked line).
import {
  getSupplierOrderDisplayNumber,
  type SupplierOrderDto,
} from '../../dto/supplierOrder';
import { coverageLineById } from '../../dto/invoiceCoverage';
import type { WorkflowInvoiceSourceLineCandidate } from '../../types/workflowInvoice';
import { asQuantityUnit } from '../../utils/commercialQuantity';
import { sourceQuantitySetFromLine, withCoverageRemainder } from './workflowInvoiceQuantity';

export function buildPurchaseSourceLineCandidates(
  order: SupplierOrderDto,
): WorkflowInvoiceSourceLineCandidate[] {
  const orderNumber = getSupplierOrderDisplayNumber(order);
  return (order.items || []).map((item) => withCoverageRemainder({
    sourceOrderLineId: item.id,
    sourceOrderId: order.id,
    orderNumber,
    productName: item.name,
    productVariantId: item.productVariantId ?? null,
    variantLabel: null,
    width: item.width ?? null,
    height: item.height ?? null,
    length: item.length ?? null,
    thickness: item.thickness ?? null,
    sourceQuantitySet: sourceQuantitySetFromLine(item),
    sourcePricingUnit: item.purchaseUnit ? asQuantityUnit(item.purchaseUnit) : null,
  }, coverageLineById(order.invoiceCoverage, item.id)));
}
